module.exports = __webpack_public_path__ + "static/integrations-teams-6fde798c0e6e820e7808a396f6f54952.png";